// import { isEmpty } from '@/utils'

const mutations = {
  setLoginState(state, isLogin) {
    state.isLogin = isLogin
  },
  setUserInfo(state, info) {
    state.userInfo = info || {}
  },
  setCompanyInfo(state, info) {
    state.companyInfo = info || {}
  },
  setOriginCompanyInfo(state, info) {
    state.originCompanyInfo = info || {}
  },
  setSysToken(state, val) {
    state.sysToken = val
  },
  setSysUid(state, val) {
    state.sysUid = val
  },
  setNavList(state, list) {
    state.navList = list || []
  },
  setOriginNavList(state, list) {
    state.originNavList = list || []
  },
  setIsGSLogin(state, hierarchyType) {
    state.isGSLogin = hierarchyType === 'GS'
  },
  setBrandList(state, list) {
    state.brandList = list || []
  },
  setShopList(state, list) {
    state.shopList = list || []
  },
  setBrandInfo(state, info) {
    let isOpenFunConfig = info.isOpenFunConfig || {}
    // 仓库管理
    if (!isOpenFunConfig.b) {
      isOpenFunConfig.b = '0'
      isOpenFunConfig.g = '0'
    }
    // 新闻
    if (!isOpenFunConfig.k) {
      isOpenFunConfig.k = '0'
    }
    // 服务员评价
    if (!isOpenFunConfig.j) {
      isOpenFunConfig.j = '0'
    }
    state.brandInfo = info || {}
  },
  setShopInfo(state, info) {
    state.shopInfo = info || {}
  },
  setRoleInfo(state, info) {
    state.roleInfo = info || {}
  },
  setAllShopList(state, list) {
    state.allShopList = list || []
  },
  setBackMenuConfig(state, list) {
    // debugger
    state.backMenuConfig = list || []
  },
  setBackPageConfig(state, list) {
    // debugger
    state.backPageConfig = list || []
  },
  setFrontPageConfig(state, list) {
    state.frontPageConfig = list || []
  },
  setBusinessMpPageConfig(state, list) {
    state.businessMpPageConfig = list || []
  },
  setAgentCompanyList(state, list) {
    state.agentCompanyList = list || []
  },
  setGroupInfo(state, info) {
    state.groupInfo = info || {}
  },
  setCompnayAccountList(state, list) {
    state.companyAccountList = list
  },
  setCustomChargeItemList(state, list) {
    state.customChargeItemList = list
  }
}

export default mutations
